/*
import { combineReducers } from "redux";

export function error(state = null, action) {
    switch (action.type) {
        case "CONFIG_BOX_ERROR":
            return action.error;

        case "CONFIG_BOX_RESET":
            return null;

        default:
            return state;
    }
}

export function loading(state = true, action) {
    switch (action.type) {
        case "CONFIG_BOX_LOADING":
            return action.loading;

        case "CONFIG_BOX_RESET":
            return false;

        default:
            return state;
    }
}

export function data(state = {}, action) {
    switch (action.type) {
        case "CONFIG_BOX_TOKEN": {
            return {
                ...state,
                ...action.data,
            };
        }

        case "CONFIG_BOX_RESET": {
            return {};
        }

        case "CONFIG_SESSION_RESET": {
            return {};
        }
        default:
            return state;
    }
}

export function settings(state = {}, action) {
    switch (action.type) {
        case "CONFIG_BOX_SETTINGS": {
            return {
                ...state,
                ...action.data,
            };
        }
        case "CONFIG_BOX_RESET": {
            return {};
        }

        case "CONFIG_SESSION_RESET": {
            return {};
        }
        default:
            return state;
    }
}

export default combineReducers({ error, loading, data, settings });
*/
import basicRequest from "../../../core/redux/reducers/request";
import { combineReducers } from "redux";

const settings = basicRequest("BOX_SETTINGS");
const token = basicRequest("BOX_TOKEN");
const users = basicRequest("BOX_USERS");
export default combineReducers({ settings, token, users });
